import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal, NgbNavModule, NgbTooltip} from '@ng-bootstrap/ng-bootstrap';
import {Contact} from '../../../model/contact';
import {FormGroup, ReactiveFormsModule, UntypedFormGroup} from "@angular/forms";
import {UserService} from "../../../services/user.service";
import {
  UserRequestComparatorComponent
} from "../../../components/common/user-request-comparator/user-request-comparator.component";
import {UserRequest} from "../../../model/UserRequest";

import {
  UsersEditModalProductsListComponent
} from "./users-edit-modal-products-list/users-edit-modal-products-list.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {UserProfileFormComponent} from "../users-create/user-profile-form/user-profile-form.component";
import {UserCoordsFormComponent} from "../users-create/user-coords-form/user-coords-form.component";
import {CancelButtonComponent} from "../../../components/common/cancel-button/cancel-button.component";
import {EditorFieldComponent} from "../../../components/common/fields/editor-field/editor-field.component";
import {UserInfosFormComponent} from "../users-create/user-infos-form/user-infos-form.component";
import {RouterLink} from "@angular/router";

@Component({
    selector: 'app-users-edit-modal',
    imports: [
    NgbNavModule,
    UsersEditModalProductsListComponent,
    FaIconComponent,
    UserProfileFormComponent,
    UserCoordsFormComponent,
    UserRequestComparatorComponent,
    CancelButtonComponent,
    NgbTooltip,
    ReactiveFormsModule,
    EditorFieldComponent,
    UserInfosFormComponent,
    RouterLink
],
    templateUrl: './users-edit-modal.component.html',
    styleUrl: './users-edit-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UsersEditModalComponent implements OnInit {
  active = 1;
  isShowingRecap = false;
  addProductMode = false;
  form: UntypedFormGroup;
  canNotSendRequest = true;
  changeUser: boolean;

  @Input('user') user: Contact;

  constructor(public activeModal: NgbActiveModal,
              private userService: UserService) {
  }

  ngOnInit(): void {
    this.form = new FormGroup({});
    this.form.valueChanges.subscribe(() => {
      if ((this.form && this.form.invalid) || this.addProductMode) {
        this.canNotSendRequest = true;
      } else {
        this.canNotSendRequest = !UserRequestComparatorComponent.isRequestDifferentFromUser(this.form.value, this.user, true);
      }
    })
  }

  showRecap(): void {
    this.isShowingRecap = true;
  }

  hideRecap(): void {
    this.isShowingRecap = false;
    this.form.removeControl('infos');
  }

  getCleanedRequest(): UserRequest {
    if (this.isShowingRecap) {
      return this.userService.cleanupEditRequest(this.form.value, this.user);
    } else {
      return null;
    }
  }

  sendRequest(): void {
    this.userService.createEditRequest(this.form.value, this.user).subscribe(p => {
      this.activeModal.close();
    });
  }

  isChangingUser(): boolean {
    return this.form.get('coords').value['firstname'] && this.user.firstname != this.form.get('coords').value['firstname'] &&
      this.form.get('coords').value['lastname'] && this.user.lastname != this.form.get('coords').value['lastname'] &&
      this.form.get('coords').value['email'] && this.user.email != this.form.get('coords').value['email'];
  }
}
